import React, { useEffect, useState } from "react";
import Header from "../../../components/Header/Header";
import LeftSideBar from "../../../components/LeftSideBar/LeftSideBar";
import {
  Box,
  FormControl,
  Grid,
  InputLabel,
  Select,
  TextField,
  Tooltip,
} from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import * as acts from "../../../redux/administrator/actions";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { IconButton, MenuItem, Menu } from "@mui/material";
import AdministratorHeader from "../../../components/Header/AdministratorHeader";
import moment from "moment";
import "./manageUser.scss";
import TablePagination from "@mui/material/TablePagination";
import CustomizedSnackbars from "../../../components/Snackbars/CustomizedSnackbars";
import ToggleOnIcon from "@mui/icons-material/ToggleOn";
import ToggleOffIcon from "@mui/icons-material/ToggleOff";
import ProgressBar from "../../../components/ProgressBar";
import { adminRoutes } from "../../../routes/routeConstants";
const Index = () => {
  const Dispatch = useDispatch();
  const navigate = useNavigate();
  const data = useSelector((state) => state?.admin?.userState);
  const apiStatus = useSelector((state) => state?.admin?.apiStatus);
  const [isOpen, setIsOpen] = useState(false);
  const [userData, setUsersData] = useState([]);
  const [text, setText] = useState("");
  const [severity, setSeverity] = useState("");
  const [loader, setLoader] = useState(false);
  useEffect(() => {
    setUsersData(data?.data);
  }, [data]);

  useEffect(() => {
    if (data?.message === "user deleted") {
      setIsOpen(true);
      setText("User deleted");
      setSeverity("success");
      Dispatch(
        acts.getUserList({
          page: 1,
          page_size: rowsPerPage,
        })
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data?.message]);

  const MyOptions = ["Edit User", "Delete User"];
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [userdata, setUserData] = React.useState(null);
  const [pageCount, setPageCount] = useState(data?.total_count || 0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [page, setPage] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedRole, setSelectedRole] = useState("");
  const [uniqueRoles, setUniqueRoles] = useState([]);

  useEffect(() => {
    if (userData?.length > 0) {
      const roles = [
        ...new Set(userData.map((u) => u.groups[0]).filter(Boolean)), // Directly map `groups` as strings
      ];
      setUniqueRoles(roles);
    }
  }, [userData]);
  // const groups

  useEffect(() => {
    setPageCount(data?.total_count);
  }, [data?.total_count]);

  const handleClick = (event, data) => {
    setAnchorEl(event.currentTarget);
    setUserData(data); // Store the selected user data
  };

  const open = Boolean(anchorEl);

  const handleClose = () => {
    setAnchorEl(null);
  };

  // const handleData = (data) => {
  //   setUserData(data);
  // };

  const handleClickOnOption = (option) => {
    handleClose();
    if (option === "Edit User") {
      // navigate("/user-form", userdata);
      // navigate("/user-form", { state: { userdata } });
      navigate( `/${adminRoutes.userForm}`, { state: { userdata } });
    } else {
      Dispatch(acts.deleteUser(userdata.id));
      // navigate("/manage-user");
      navigate(`/${adminRoutes.manageUser}`)
    }
  };

  useEffect(() => {
    if (apiStatus && apiStatus !== undefined) {
      if (apiStatus?.message !== null && apiStatus?.next === false) {
        if (apiStatus?.apiError === true) {
          setIsOpen(true);
          setText(apiStatus?.message);
          setSeverity("error");
        }
      } else if (
        apiStatus?.apiSuccess === true &&
        apiStatus?.next === true &&
        apiStatus?.notification === true
      ) {
        setIsOpen(true);
        Dispatch(
          acts.getUserList({
            page: 1,
            page_size: rowsPerPage,
          })
        );
        setText(apiStatus?.message);
        setSeverity("success");
        setLoader(false);
      }
    }
  }, [apiStatus]);

  useEffect(() => {
    Dispatch(
      acts.getUserList({
        page: page + 1,
        page_size: rowsPerPage,
      })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Dispatch, rowsPerPage]);

  const handlePageChange = (event, value) => {
    setPage(value);
    Dispatch(
      acts.getUserList({
        page: value + 1,
        page_size: rowsPerPage,
      })
    );
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(event.target.value);
    setPage(0);
  };
  const handleActive = (data) => {
    setLoader(true);
    data = {
      id: data.id,
    };
    Dispatch(acts.userStatus(data));
  };
  return (
    <>
      <Header page="new-project" />
      {isOpen ? (
        <CustomizedSnackbars
          className="popup"
          handleClose={() => {
            // isOpen = false;
            setIsOpen(false);
          }}
          severity={severity}
          state={isOpen}
          text={text}
        />
      ) : (
        <></>
      )}
      <Box>
        <Grid className="sidebar-main" container>
          <Grid item className="sidebar-container">
            <LeftSideBar page="sidebar" />
          </Grid>
          <Grid item className="visualization-conatiner">
            <AdministratorHeader
              position="right"
              text="Add New User"
              isShow={true}
              // to="/user-form"
              to={`/${adminRoutes.userForm}`}
            />
            <Box>
              <Box sx={{ display: "flex", gap: 2, p: 2 }}>
                <FormControl size="small" sx={{ minWidth: 200 }}>
                  <InputLabel>Filter by Role</InputLabel>
                  <Select
                    label="Filter by Role"
                    value={selectedRole}
                    onChange={(e) => setSelectedRole(e.target.value)}
                  >
                    <MenuItem value="">All Roles</MenuItem>
                    {uniqueRoles.map((role) => (
                      <MenuItem key={role} value={role}>
                        {role?.replace(/\b\w/g, (char) => char.toUpperCase())}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                <TextField
                  size="small"
                  label="Search by Name"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  sx={{ minWidth: 200 }}
                />
              </Box>

              <Box className="manage-user-table-container">
                <TableContainer
                  className="manageUser-container"
                  component={Paper}
                >
                  <Table
                    stickyHeader
                    aria-label="simple table"
                    className="parent-table"
                  >
                    <TableHead className="parent-table-th">
                      <TableRow className="parent-table-row">
                        <TableCell align="left"></TableCell>
                        <TableCell align="left">Name</TableCell>
                        <TableCell align="left">Email</TableCell>
                        <TableCell align="left">Role</TableCell>
                        <TableCell align="left">Created Date</TableCell>
                        <TableCell align="left">Status</TableCell>
                        <TableCell align="left">Action</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {userData
                        ?.filter((user) => {
                          const matchesRole = selectedRole
                            ? Array.isArray(user.groups)
                              ? user.groups.includes(selectedRole)
                              : user.groups === selectedRole
                            : true;

                          const matchesName = searchTerm
                            ? user.username
                                ?.toLowerCase()
                                .includes(searchTerm.toLowerCase())
                            : true;

                          return matchesRole && matchesName;
                        })
                        .map((data) => {
                          return (
                            <>
                              <TableRow key={data.id} className="border-0">
                                <TableCell>
                                  {/* <span className="checkboxicon"></span> */}
                                </TableCell>
                                <TableCell align="left">
                                  {data?.username}
                                </TableCell>
                                <TableCell align="left">
                                  {data?.email}
                                </TableCell>
                                <TableCell align="left">
                                  {data?.groups}
                                </TableCell>
                                <TableCell align="left">
                                  {moment(data?.date_joined).format(
                                    "MMM DD YYYY"
                                  )}
                                </TableCell>
                                <TableCell align="left">
                                  {data.is_active ? (
                                    <Tooltip title="Active">
                                      <IconButton
                                        onClick={() => handleActive(data)}
                                      >
                                        <ToggleOnIcon
                                          sx={{ color: "#2776d2" }}
                                        />
                                      </IconButton>
                                    </Tooltip>
                                  ) : (
                                    <Tooltip title="Inactive">
                                      <IconButton
                                        onClick={() => handleActive(data)}
                                      >
                                        <ToggleOffIcon
                                          sx={{ color: "#c62828" }}
                                        />
                                      </IconButton>
                                    </Tooltip>
                                  )}
                                </TableCell>
                                <TableCell>
                                  <IconButton
                                    aria-label="more"
                                    onClick={(event) =>
                                      handleClick(event, data)
                                    }
                                    aria-haspopup="true"
                                    aria-controls="long-menu"
                                  >
                                    <MoreVertIcon
                                    // onClick={handleClick}

                                    // onClick={() => {
                                    //   handleData(data);
                                    // }}
                                    />
                                  </IconButton>
                                  <Menu
                                    anchorEl={anchorEl}
                                    keepMounted
                                    onClose={handleClose}
                                    open={open}
                                  >
                                    {MyOptions.map((option) => (
                                      <MenuItem
                                        key={option}
                                        onClick={() => {
                                          handleClickOnOption(option);
                                        }}
                                      >
                                        {option}
                                      </MenuItem>
                                    ))}
                                  </Menu>
                                </TableCell>
                              </TableRow>
                            </>
                          );
                        })}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
              {loader && <ProgressBar />}
            </Box>
            <Grid className="pagination-wrap pagination-bg">
              <TablePagination
                component="div"
                rowsPerPageOptions={[100, 200, 300, 500]}
                count={parseInt(pageCount)}
                page={parseInt(page)}
                onPageChange={handlePageChange}
                rowsPerPage={parseInt(rowsPerPage)}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default Index;
